import rootStore from '../store'

/**
 * Default Global Authorization Guard
 */
export default function (to, from, next) {
  const store = rootStore

  if (to.matched.some(function (record) { return record.meta.requiresAuth })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
}



// WEBPACK FOOTER //
// ./src/router/authGuard.js